import { useBackofficeCountry } from "./BackofficeCountryContext";
import backofficeApi from "./topchef-api-backoffice";
import { LeadCreation, LocHallBill } from "./topchef.types";
import { useMemo } from "react";

/**
 * Hook wrapping all backoffice API calls.
 * Automatically injects the selected country into every request.
 */
export function useBackofficeApi() {
  const { selectedCountry } = useBackofficeCountry();
  const country = selectedCountry.code;

  return useMemo(() => ({
    country,
    getLoggedIAdmin: () => backofficeApi.getLoggedIAdmin(),
    loadAllLeads: () => backofficeApi.loadAllLeads(country),
    loadLeadDetails: (leadId: string) => backofficeApi.loadLeadDetails(leadId, country),
    loadLeadsToValidate: () => backofficeApi.loadLeadsToValidate(country),
    loadLeadToValidate: (leadId: string) => backofficeApi.loadLeadToValidate(leadId, country),
    validateLead: (leadId: string, leadCreation: LeadCreation) =>
      backofficeApi.validateLead(leadId, leadCreation),
    refuseLead: (leadId: string) => backofficeApi.refuseLead(leadId, country),
    loadBillsToValidate: () => backofficeApi.loadBillsToValidate(country),
    loadLeadWithBillToValidate: (leadId: string) =>
      backofficeApi.loadLeadWithBillToValidate(leadId, country),
    downloadBill: (leadId: string) => backofficeApi.downloadBill(leadId),
    validateBill: (leadId: string, bill: LocHallBill) =>
      backofficeApi.validateBill(leadId, bill, country),
    loadAvailableLeads: () => backofficeApi.loadAvailableLeads(country),
    loadSignedLeads: () => backofficeApi.loadSignedLeads(country),
    loadActivedPlaces: () => backofficeApi.loadActivedPlaces(country),
    loadUpdatedLead: (leadId: string, updatedData: LeadCreation) =>
      backofficeApi.loadUpdatedLead(leadId, updatedData, country),
  }), [country]);
}
